<template>
  <f7-page
    :page-content="false"
  >
    <f7-navbar
      class="bg-madai"
      :sliding="false"
      back-link
    >
      <f7-nav-title class="text-white" title="Diseño Personalizado" subtitle="Anillo de Compromiso"></f7-nav-title>
    </f7-navbar>

    <f7-toolbar tabbar position="top">
      <f7-link tab-link="#tab-1" :tab-link-active="tabSeleccionado === 0" @click="tabSeleccionado = 0">
        <i class="material-icons">description</i>
      </f7-link>
      <f7-link tab-link="#tab-2" :tab-link-active="tabSeleccionado === 1" @click="tabSeleccionado = 1">
        <img src="assets/img/menu/compromiso.svg" alt="" width="28" class="m-l-0">
      </f7-link>
      <f7-link tab-link="#tab-5" :tab-link-active="tabSeleccionado === 2" @click="tabSeleccionado = 2">
        <i class="material-icons">assignment_turned_in</i>
      </f7-link>
      <f7-link tab-link="#tab-6" :tab-link-active="tabSeleccionado === 3" @click="tabSeleccionado = 3">
        <i class="material-icons">person</i>
      </f7-link>
    </f7-toolbar>
    <f7-tabs>
      <f7-tab id="tab-1" class="page-content" :tab-active="tabSeleccionado === 0">
        <f7-block class="m-b-15 bold">¿Quieres algo para ti? ó ¿Para alguien especial?</f7-block>
        <f7-list class="m-t-0" >
          <f7-list-item class="required" title="Selecciona una opción" smart-select>
            <select name="para-quien-es">
              <option value="Para mi" selected>Para mi</option>
              <option value="Alguien más">Alguien más</option>
              <option value="Para mi y alguien más">Para mi y alguien más</option>
            </select>
          </f7-list-item>
        </f7-list>

        <f7-block class="m-b-15 bold">¿Tienes un diseño en mente? o ¿Te gustaría que te propusieramos ideas?</f7-block>
        <f7-list class="m-t-0" >
          <f7-list-item class="required" title="Selecciona una opción" smart-select>
            <select name="diseno-en-mente">
              <option value="Ya sé que diseño va a tener" selected>Ya sé que diseño va a tener</option>
              <option value="No estoy seguro (a) de cómo será, pero tengo ideas">No estoy seguro (a) de cómo será, pero tengo ideas</option>
              <option value="Me gustaría recibir ideas">Me gustaría recibir ideas</option>
            </select>
          </f7-list-item>
        </f7-list>

        <f7-block class="m-b-15 bold">Háznos saber si tienes una fecha planeada para asegurarnos de tenerlo a tiempo</f7-block>
        <f7-list class="m-t-0" >
          <f7-list-item class="required" title="Selecciona una opción" smart-select>
            <select name="diseno-en-mente">
              <option value="Sí, tengo fecha" selected>Sí, tengo fecha</option>
              <option value="No tengo fecha, pero sí será pronto (menos de 3 meses)">No tengo fecha, pero sí será pronto (menos de 3 meses)</option>
              <option value="No tengo fecha, pero no hay prisa (mas de 3 meses)">No tengo fecha, pero no hay prisa (mas de 3 meses)</option>
              <option value="Solo estoy cotizando por ahora">Solo estoy cotizando por ahora</option>
            </select>
          </f7-list-item>
          <li class="required">
            <div class="item-content item-input">
              <div class="item-inner">
                <div class="item-title item-label">Selecciona la fecha de entrega</div>
                <div class="item-input-wrap">
                  <input
                    type="text"
                    readonly="readonly"
                    placeholder="Selecciona la fecha de entrega"
                    ref="fechaPlaneada"
                  />
                </div>
              </div>
            </div>
          </li>
        </f7-list>

        <f7-block class="m-b-15 bold required">¿Cuál es tu rango de precio?</f7-block>
        <f7-block class="m-0 m-b-100">
          <f7-list class="f7-list-item-no-border m-0">
            <f7-list-item>
              <f7-range
                ref="precio"
                :min="5000"
                :max="200000"
                :step="1000"
                :value="[0, 200000]"
                :label="true"
                :dual="true"
              ></f7-range>
            </f7-list-item>
          </f7-list>
        </f7-block>
      </f7-tab>
      <f7-tab id="tab-2" class="page-content" :tab-active="tabSeleccionado === 1">
        <f7-block>
          <ringmaker-mini v-bind:width="320" v-bind:height="230"></ringmaker-mini>
          <f7-swiper class="m-t-10" navigation :params="{speed:500, slidesPerView: 3, spaceBetween: 20}">
            <f7-swiper-slide>Slide 1</f7-swiper-slide>
            <f7-swiper-slide>Slide 2</f7-swiper-slide>
            <f7-swiper-slide>Slide 3</f7-swiper-slide>
          </f7-swiper>
        </f7-block>
      </f7-tab>
      <f7-tab id="tab-3" class="page-content" :tab-active="tabSeleccionado === 2">
        <f7-block class="m-b-15 bold">¿El anillo llevará algún grabado?</f7-block>
        <f7-list class="m-t-0" >
          <f7-list-item title="Selecciona una opción" smart-select :smart-select-params="{openIn: 'popover'}">
            <select name="seleccion-medida">
              <option value="medida-no" selected>No</option>
              <option value="medida-si">Si</option>
            </select>
          </f7-list-item>
          <f7-list-input
            class="required"
            label="Escribe lo que se grabará"
            type="text"
            placeholder="Escribelo aquí"
          ></f7-list-input>
        </f7-list>

        <f7-block class="m-b-15 bold">Información Adicional</f7-block>
        <f7-list class="m-t-0" >
          <f7-list-input
            label="Información adicional"
            type="textarea"
            placeholder="Escribela aquí"
          >
          </f7-list-input>
        </f7-list>

        <f7-block class="m-b-15 bold">Adjuntar imagenes</f7-block>
        <!-- <f7-block class="m-b-15 bold">Titulo</f7-block>
        <f7-list class="m-t-0" >
          <f7-list-item class="required" title="Selecciona una opción" smart-select>
            <select name="seleccion_color">
              <option value="" data-option-image="assets/img/cuestionario_img/.png" selected></option>
              <option value="" data-option-image="assets/img/cuestionario_img/.png"></option>
              <option value="" data-option-image="assets/img/cuestionario_img/.png"></option>
            </select>
          </f7-list-item>
        </f7-list> -->
      </f7-tab>
      <f7-tab id="tab-4" class="page-content" :tab-active="tabSeleccionado === 3">
        <f7-block class="m-b-15 bold">Información personal</f7-block>
        <f7-list class="m-t-0" >
          <f7-list-input
            class="required"
            label="Nombre Completo"
            type="text"
            placeholder="Nombre"
          ></f7-list-input>
          <f7-list-input
            class="required"
            label="Celular o Whatsapp"
            type="text"
            placeholder="Número"
          ></f7-list-input>
          <f7-list-input
            class="required"
            label="Correo Electrónico"
            type="text"
            placeholder="Correo"
          ></f7-list-input>
        </f7-list>

        <f7-block class="bold text-danger">
          La información personal se mantendrá estrictamente confidencial y no se venderá, reutilizará, alquilará,
          prestará ni divulgará de otro modo. Solo se utilizará como medio de contacto para hacerte llegar la cotización.
        </f7-block>

        <f7-list class="m-b-80" inset>
          <f7-list-item>
            <f7-button class="margin-auto" fill>Enviar</f7-button>
          </f7-list-item>
        </f7-list>
      </f7-tab>
    </f7-tabs>

    <f7-toolbar tabbar position="bottom">
      <f7-link @click="tabSeleccionado > 0 ? tabSeleccionado-- : tabSeleccionado">Anterior</f7-link>
      <f7-link @click="tabSeleccionado < tabs.length-1 ? tabSeleccionado++ : tabSeleccionado">Siguiente</f7-link>
    </f7-toolbar>
  </f7-page>
</template>

<script>
import ringmakerMini from '@/components/ringmaker'

export default {
  components: {
    ringmakerMini
  },
  data () {
    return {
      tabs: [1, 2, 3, 4],
      tabSeleccionado: 0
    }
  },
  created () {
    this.$f7.utils.nextFrame(() => {
      this.$f7.calendar.create({
        inputEl: this.$refs.fechaPlaneada,
        dateFormat: 'yyyy/mm/dd',
        value: [new Date()]
      })
    })
  }
}
</script>

<style>
.subtitle {
  color: #fff !important;
}

.navbar {
  background-color: #1D2244 !important;
  color: #fff;
}

.swiper-slide {
  background: #fff;
  text-align: center;
  font-size: 18px;
  line-height: 100px;
  box-sizing: border-box;
  border: 1px solid #ccc;
}
</style>
